import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between gap-3" };
const _hoisted_2 = { class: "flex flex-col gap-px min-w-0" };
const _hoisted_3 = { class: "flex items-center gap-1.5 min-w-0" };
const _hoisted_4 = ["href", "aria-label"];
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = {
    key: 0,
    class: "text-xs text-(--text-text-black-default)"
};
const _hoisted_7 = { class: "flex items-center gap-2 shrink-0" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Badge, PhoneDisplay, Popover, formatPhoneForDisplay } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactChannelRow',
    props: {
        channel: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const isPhone = computed(() => props.channel.type === "Phone");
        /** Click-to-contact target for the email branch — PhoneDisplay builds its own tel: href. */
        const contactHref = computed(() => `mailto:${props.channel.value}`);
        /**
         * Accessible name describing the action. Required (not optional): because the
         * link keeps a plain-text appearance, this label and the focus ring are the
         * primary affordances for keyboard and assistive-technology users. The phone
         * branch interpolates the FORMATTED value so the announced name matches the
         * visible text (WCAG 2.5.3) — PhoneDisplay renders the number grouped, not raw.
         */
        const actionLabel = computed(() => isPhone.value
            ? t("contact.detail.contactInformation.callAriaLabel", {
                value: formatPhoneForDisplay(props.channel.value),
            })
            : t("contact.detail.contactInformation.sendEmailAriaLabel", { value: props.channel.value }));
        const primaryLabel = computed(() => isPhone.value
            ? t("contact.detail.contactInformation.telephonePrincipal")
            : t("contact.detail.contactInformation.emailPrincipal"));
        const sharedRoleIcon = computed(() => {
            if (!props.channel.sharedOwnerRole)
                return null;
            return props.channel.sharedOwnerRole === "Principal"
                ? "ri-shield-user-line"
                : "ri-group-2-line";
        });
        const sharedRoleTooltipHeader = computed(() => props.channel.sharedOwnerRole === "Principal"
            ? t("contact.detail.contactInformation.sharedEmailPrincipalTooltipHeader")
            : t("contact.detail.contactInformation.sharedEmailSecondaryTooltipHeader"));
        const sharedRoleTooltipText = computed(() => props.channel.sharedOwnerRole === "Principal"
            ? t("contact.detail.contactInformation.sharedEmailPrincipalTooltip")
            : t("contact.detail.contactInformation.sharedEmailSecondaryTooltip"));
        const helperText = computed(() => {
            const { usage, linkedOrganisationName, type } = props.channel;
            if (!usage)
                return null;
            if (usage === "Professional") {
                return (linkedOrganisationName ??
                    (type === "Phone"
                        ? t("contact.detail.contactInformation.telephoneProfessionnel")
                        : t("contact.detail.contactInformation.emailProfessionnel")));
            }
            return type === "Phone"
                ? t("contact.detail.contactInformation.telephonePersonnel")
                : t("contact.detail.contactInformation.emailPersonnel");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (isPhone.value)
                            ? (_openBlock(), _createBlock(_unref(PhoneDisplay), {
                                key: 0,
                                value: __props.channel.value,
                                "aria-label": actionLabel.value,
                                class: "text-sm font-medium text-(--text-text-link) truncate no-underline hover:no-underline cursor-pointer rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--colors-border-accent)"
                            }, null, 8 /* PROPS */, ["value", "aria-label"]))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: contactHref.value,
                                "aria-label": actionLabel.value,
                                class: "text-sm font-medium text-(--text-text-link) truncate no-underline hover:no-underline cursor-pointer rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--colors-border-accent)"
                            }, _toDisplayString(__props.channel.value), 9 /* TEXT, PROPS */, _hoisted_4)),
                        (sharedRoleIcon.value)
                            ? (_openBlock(), _createBlock(_unref(Popover), {
                                key: 2,
                                position: "top",
                                header: sharedRoleTooltipHeader.value
                            }, {
                                trigger: _withCtx(({ triggerProps }) => [
                                    _createElementVNode("button", _mergeProps(triggerProps, {
                                        type: "button",
                                        class: "shrink-0 size-5 flex items-center justify-center rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--colors-border-accent)",
                                        "aria-label": sharedRoleTooltipHeader.value
                                    }), [
                                        _createElementVNode("i", {
                                            class: _normalizeClass([[sharedRoleIcon.value, sharedRoleIcon.value === 'ri-shield-user-line' ? 'text-(--colors-icon-cyan)' : 'text-(--colors-icon-success)'], "text-xl leading-none"]),
                                            "aria-hidden": "true"
                                        }, null, 2 /* CLASS */)
                                    ], 16 /* FULL_PROPS */, _hoisted_5)
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(sharedRoleTooltipText.value), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["header"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    (helperText.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(helperText.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    (__props.channel.isPrimary)
                        ? (_openBlock(), _createBlock(_unref(Badge), {
                            key: 0,
                            theme: "yellow",
                            size: "sm",
                            label: primaryLabel.value,
                            "show-left-icon": false,
                            "show-close-icon": false
                        }, null, 8 /* PROPS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _renderSlot(_ctx.$slots, "actions")
                ])
            ]));
        };
    }
});
